import { Component, Input, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { DynamicFormLandingComponent } from '../../../dynamic-form-landing/dynamic-form-landing.component';
import { DynamicFormSection } from 'src/app/_models/widget.models';
import { EvacUiState } from 'src/app/_models/emergency.models';
import { EmergencyEvacuationService } from 'src/app/_services/emergency/emergency-evacuation.service';

/**
 * Smart component for the SOS/Emergency Evacuation widget.
 * Delegates all state management and API calls to EmergencyEvacuationService.
 */
@Component({
  selector: 'app-sos-sign',
  templateUrl: './sos-sign.component.html',
  styleUrls: ['./sos-sign.component.scss'],
})
export class SosSignComponent {
  @Input() evacuationFormSections: DynamicFormSection[] | null = null;
  @Input() drillFormSections: DynamicFormSection[] | null = null;

  @ViewChild('evacForm') evacForm: DynamicFormLandingComponent;
  @ViewChild('drillForm') drillForm: DynamicFormLandingComponent;

  readonly state$: Observable<EvacUiState>;

  constructor(private evacuationService: EmergencyEvacuationService) {
    this.state$ = this.evacuationService.state$;
  }

  onEvacFieldChanged(): void {
    const formData = this.evacForm?.onSubmit();
    const reason: string = formData?.value?.evacReason ?? '';
    this.evacuationService.validateReason(reason, 'evacuation');
  }

  onDrillFieldChanged(): void {
    const formData = this.drillForm?.onSubmit();
    const reason: string = formData?.value?.drillReason ?? '';
    this.evacuationService.validateReason(reason, 'drill');
  }

  sendEvacuation(): void {
    const reason: string = this.evacForm?.onSubmit()?.value?.evacReason ?? '';
    this.evacuationService.sendNotification('evacuation', reason);
  }

  sendDrill(): void {
    const reason: string = this.drillForm?.onSubmit()?.value?.drillReason ?? '';
    this.evacuationService.sendNotification('drill', reason);
  }
}
